module.exports = __webpack_public_path__ + "static/media/FacePhoto.b10a9516.png";